import { unwrap, type components } from "@wilco/api";
import { api } from "../auth.ts";
import type { ListQuery } from "../docs/DocumentList.tsx";
import { idempotency } from "../docs/DocumentForm.tsx";
import { pageQuery } from "../docs/serverPage.ts";

/*
 * Списки «Довідника» страницами сервера: товары и версии (catalog),
 * справочник прошивок и квалификации (route: их ведёт мастер дільниці,
 * а живут они в маршруте), сотрудники для выбора (hr).
 */
type S = components["schemas"];
type PageArgs = Pick<ListQuery, "cursor" | "limit" | "q">;

export type TemplateRow = S["CatalogTemplateRow"];
export type VersionRow = S["CatalogVersionRow"];
export type FirmwareRow = S["RouteFirmwareRow"];
export type SkillRow = S["RouteSkillRow"];
export type Employee = S["HrEmployee"];

const query = (a: PageArgs) => ({ ...pageQuery(a), q: a.q || undefined });

export const directoryApi = {
  templates: (a: PageArgs & { archived: boolean | null }) =>
    unwrap(api.GET("/api/v1/catalog/templates", { params: { query: { ...query(a), archived: a.archived ?? undefined } } })),
  versions: (a: PageArgs & { archived: boolean | null }) =>
    unwrap(api.GET("/api/v1/catalog/versions", { params: { query: { ...query(a), archived: a.archived ?? undefined } } })),
  firmware: (a: PageArgs & { active: boolean | null }) =>
    unwrap(api.GET("/api/v1/route/firmware", { params: { query: { ...query(a), active: a.active ?? undefined } } })),
  addFirmware: (productId: string, version: string, key: string) =>
    unwrap(api.POST("/api/v1/route/products/{productId}/firmware", { params: { path: { productId } }, body: { version }, headers: idempotency(key) })),
  archiveFirmware: (productId: string, version: string) =>
    unwrap(api.POST("/api/v1/route/products/{productId}/firmware/{version}/archive", { params: { path: { productId, version } } })),
  skills: (a: PageArgs) => unwrap(api.GET("/api/v1/route/skills", { params: { query: query(a) } })),
  grantSkill: (employeeId: string, skill: string, key: string) =>
    unwrap(api.POST("/api/v1/route/employees/{employeeId}/skills", { params: { path: { employeeId } }, body: { skill }, headers: idempotency(key) })),
  revokeSkill: (employeeId: string, skill: string) =>
    unwrap(api.DELETE("/api/v1/route/employees/{employeeId}/skills/{skill}", { params: { path: { employeeId, skill } } })),
  employees: () => unwrap(api.GET("/api/v1/hr/employees")),
};
